import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { CordFinanceService, CordIamService } from '@yellowtail-frontend/cord-connector';
import { StorageService } from '@yellowtail-frontend/storage-service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { OcktoReceiverApiService, UniveWrapperApiService } from '@unive/core';
import { environment } from 'src/environments/environment';

registerLocaleData(localeNl, 'nl');

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, CommonModule, AppRoutingModule, BrowserAnimationsModule],
  providers: [
    { provide: LOCALE_ID, useValue: 'nl' },
    provideAnimations(),
    {
      provide: StorageService,
      useValue: new StorageService({
        useEncryption: environment.useEncryption,
        sessionTimeToLive: environment.sessionTimeToLive,
      }),
    },
    { provide: CordIamService, useValue: new CordIamService(environment.cordIamBaseUrl) },
    { provide: CordFinanceService, useValue: new CordFinanceService(environment.cordFinanceBaseUrl) },
    { provide: OcktoReceiverApiService, useValue: new OcktoReceiverApiService(environment.ocktoReceiverBaseUrl) },
    { provide: UniveWrapperApiService, useValue: new UniveWrapperApiService(environment.univeWrapperBaseUrl) },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
